import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/react-bootstrap/esm/Button.js");
;
import(/* webpackMode: "eager" */ "/app/src/app/(mkgeu)/nieuws/[id]/[titel]/Nieuws.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["RightMouseClickMenu"] */ "/app/src/components/RightMouseClickMenu/RightMouseClickMenu.jsx");
;
import(/* webpackMode: "eager" */ "/app/src/partials/MkgEu/NieuwsOverzicht/NieuwsOverzicht.module.scss");
